import { storeMixin, storeGenerator } from '@/storeMixin'
import { merge } from 'lodash'

const organizationform = merge(storeMixin.getMixin(), {
  state: {
    apiUrl: '/api/v1/organization/{profile}/organization-form',
    app: 'organization'
  }
})

const TYPES = (() =>
  merge(
    storeGenerator(
      { profile: 'GENERIC', app: 'organization', model: 'organizationform' }
    ),
    { }
  )
)()

export { organizationform, TYPES }
